import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HandleError, HttpErrorHandler } from '../../http-error-handler.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ConsultaCepService {

    private env = environment;
    private handleError: HandleError;

    constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
        this.handleError = httpErrorHandler.createHandleError('ConsultaCepService');
    }

    consultarCEP(cep: string) {
        // Nova variável "cep" somente com dígitos.
        cep = cep.replace(/\D/g, '');

        // Verifica se campo cep possui valor informado.
        if (cep) {
            return this.http
                .get(`${this.env.API_ENDPOINT_VIACEP.link}/${cep}/json`)
                .pipe(
                    catchError(this.handleError('Adicionar Autoridade de Registro', []))
                );
        }
    }

}
